import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import repeatElement from '@gik/core/utils/repeatElement';
import { FrameBone, ParagraphBone } from '@gik/ui';
import { useRandomInt } from '@gik/core/utils/getRandomInt';

export default function ClaimsListSkeleton() {
  const bem = bemBlock('claimed-items-skeleton');
  const repeat = useRandomInt(3, 10);

  return (
    <div className={bem()}>
      {repeatElement(
        repeat,
        <FrameBone className={bemBlock('claimed-item-card')()}>{repeatElement(2, <InnerParagraphBone />)}</FrameBone>
      )}
    </div>
  );
}

function InnerParagraphBone() {
  const words = useRandomInt(2, 6);
  return <ParagraphBone words={words} />;
}
